import React from 'react';
import cx from 'classnames';
import './UnderlinedText.css';

export type UnderlinedTextProps = {
  children?: string;
  color?: 'teal' | 'hardPink' | 'white' | 'coveBlue';
  borderTopLeftRadius?: string;
  borderTopRightRadius?: string;
  borderBottomRightRadius?: string;
  borderBottomLeftRadius?: string;
  thick?: boolean;
};

const UnderlinedText: React.FC<UnderlinedTextProps> = ({
  children,
  color = 'teal',
  thick = false,
  borderTopLeftRadius = '100%',
  borderTopRightRadius = '100%',
  borderBottomRightRadius = '20px',
  borderBottomLeftRadius = '0px',
}) => {
  const classes = cx('underlined-text__underline', `underlined-text__underline--${color}`, {
    thick,
  });
  return (
    <span className="underlined-text">
      {children}
      <span
        className={classes}
        style={{
          borderTopLeftRadius,
          borderTopRightRadius,
          borderBottomRightRadius,
          borderBottomLeftRadius,
        }}
      />
    </span>
  );
};

export default UnderlinedText;
